import formatDate from '../helpers/formatDate.js';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default class PendingTransactionsStatement {

    #LEFT_MARGIN = 14;
    #RIGHT_MARGIN = 200;
    #CURRENT_Y = 0;

    constructor(data, logoUrl = null) {
        const now = new Date();
        this.customer = data;
        this.statementDate = formatDate(now.toISOString());
        this.doc = new jsPDF();
        this.logoBase64 = null;
    }

    
    async loadLogoFromUrl(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
    
        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                this.logoBase64 = reader.result;
                resolve();
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    

    renderCompanyHeader() {
        this.doc.setFontSize(12);
        this.doc.text('Swallow Dental Supplies Ltd.', this.#LEFT_MARGIN, 15);
        this.doc.setFontSize(10);
        this.doc.text('Unit 5 Marrtree Business Park', this.#LEFT_MARGIN, 20);
        this.doc.text('Ryefield Way', this.#LEFT_MARGIN, 25);
        this.doc.text('Silsden, West Yorkshire, BD20 0EF', this.#LEFT_MARGIN, 30);
        this.doc.text('United Kingdom', this.#LEFT_MARGIN, 35);
        this.doc.text('T 01535 656312    F 01535 656437', this.#LEFT_MARGIN, 40);
        this.doc.text('VAT Reg No. 721604174    Co. Reg. 03652780', this.#LEFT_MARGIN, 45);
    }

    renderStatementTitle() {
        if (this.logoBase64) {
            this.doc.addImage(this.logoBase64, 'PNG', this.#RIGHT_MARGIN - 40, 15, 40, 13);
        }
        // this.doc.setFontSize(14);
        // this.doc.setFont(undefined, 'bold');
        // this.doc.text('Statement of Account', this.#RIGHT_MARGIN, 15, { align: 'right' });
        // this.doc.setFont(undefined, 'normal');
    }

    renderCustomerDetails() {
        this.doc.setFontSize(10);
        this.doc.setFont(undefined, 'bold');
        this.doc.text('CUSTOMER DETAILS', this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.#CURRENT_Y += 6;
        this.doc.text(`${this.customer.firstName} ${this.customer.lastName}`, this.#LEFT_MARGIN, this.#CURRENT_Y);
        if(this.customer.defaultBillingAddress.company){
            this.#CURRENT_Y += 5;
            this.doc.text(this.customer.defaultBillingAddress.company, this.#LEFT_MARGIN, this.#CURRENT_Y);
        }
        this.#CURRENT_Y += 5;
        this.doc.text(this.customer.defaultBillingAddress.street1, this.#LEFT_MARGIN, this.#CURRENT_Y);
        if(this.customer.defaultBillingAddress.street2){
            this.#CURRENT_Y += 5;
            this.doc.text(this.customer.defaultBillingAddress.street2, this.#LEFT_MARGIN, this.#CURRENT_Y);
        }
        this.#CURRENT_Y += 5;
        this.doc.text(`${this.customer.defaultBillingAddress.city}, ${this.customer.defaultBillingAddress.postcode}`, this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.#CURRENT_Y += 5;
        this.doc.text(`${this.customer.defaultBillingAddress.country}`, this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.#CURRENT_Y += 7;
        this.doc.text(`Account No: ${this.customer.accountNumber}`, this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.#CURRENT_Y += 5;
        this.doc.text(`Tel No: ${this.customer.phoneNumber}`, this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.#CURRENT_Y += 5;
        this.doc.text(`Email: ${this.customer.email}`, this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.#CURRENT_Y += 5;
        this.doc.text('Currency: GBP', this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.#CURRENT_Y += 5;
        this.doc.text(`Statement Date: ${this.statementDate}`, this.#LEFT_MARGIN, this.#CURRENT_Y);
    }

    renderInvoiceTable()
    {
        this.#CURRENT_Y += 10;

        const transactions = this.customer.transactions;
        const rows = transactions.map(t => [
            t.id,
            t.attributes.documentType,
            formatDate(t.attributes.documentDate),
            t.attributes.documentType == 'Invoice' && t.attributes.dueDate ? formatDate(t.attributes.dueDate) : 'N/A',
            `£${parseFloat(t.attributes.outstandingValue).toFixed(2)}`,
            `£${parseFloat(t.attributes.outstandingValue).toFixed(2)}`,
        ]);

        const totalOutstanding = transactions.reduce((sum, t) => {
            return sum + parseFloat(t.attributes.outstandingValue || 0);
        }, 0);

        autoTable(this.doc, {
            startY: this.#CURRENT_Y,
            head: [['Document Number', 'Document Type', 'Document Date', 'Due Date', 'Amount', 'Outstanding Amount']],
            body: rows,
            foot: [['', '', '', '', 'Total', `£${totalOutstanding.toFixed(2)}`]],
            headStyles: {
                fillColor: '#020023',
                textColor: '#ffffff',
            },
            footStyles: {
                fontStyle: 'bold',
                fillColor: [240, 240, 240],
                textColor: '#000000',
            },
            styles: { 
                fontSize: 10,
                textColor: '#020023',
            },
            theme: 'grid'
        });
    }

    renderDocumentFooter()
    {
        // Aged Analysis section (dummy values)
        const finalY = this.doc.lastAutoTable.finalY + 10;
        // doc.setFont(undefined, 'bold');
        // doc.text('Aged Analysis', this.#LEFT_MARGIN, finalY);
        // doc.setFont(undefined, 'normal');
        // doc.text('1 - 29 Days    30 - 59 Days    60 - 89 Days    90 - 119 Days    120+ Days', this.#LEFT_MARGIN, finalY + 6);
        // doc.text('£0.00           £0.00             £0.00             £9.84             £0.00', this.#LEFT_MARGIN, finalY + 12);

        // Bank details
        const bankY = finalY + 25;
        this.doc.setFont(undefined, 'bold');
        this.doc.text('Bank Payment', this.#LEFT_MARGIN, bankY);
        
        this.doc.setFont(undefined, 'normal');
        this.doc.text('Swallow Dental Supplies Ltd', this.#LEFT_MARGIN, bankY + 8);
        this.doc.text('Account No: 63590660', this.#LEFT_MARGIN, bankY + 13);
        this.doc.text('Sort Code: 30-63-55', this.#LEFT_MARGIN, bankY + 19);

        this.doc.text('Please use your Account No. shown above as the reference.', this.#LEFT_MARGIN, bankY + 25, {
            maxWidth: 80
        });
        
        this.doc.setFont(undefined, 'bold');
        this.doc.text('Card Payment', this.#LEFT_MARGIN + 90, bankY);
        this.doc.setFont(undefined, 'normal');
        this.doc.text('Please call 01535 656312 (option 3) to use our 24/7 payment line.', this.#LEFT_MARGIN + 90, bankY + 8, {
            maxWidth: 80
        });
        this.doc.text('Or email finance@swallowdental.co.uk to request an Opayo PayByLink.', this.#LEFT_MARGIN + 90, bankY + 19, {
            maxWidth: 80
        });

        // Footer
        this.doc.setFontSize(10);
        this.doc.text(`Date Printed: ${this.statementDate}`, this.#LEFT_MARGIN, 285);
        this.doc.text('Page 1 of 1', this.#RIGHT_MARGIN, 285, { align: 'right' });
    }

    async generate()
    {
        // Company Header (Top Left)
        this.renderCompanyHeader();

        // Statement Title (Top Right)
        this.renderStatementTitle();

        // Customer Details Section
        this.#CURRENT_Y = 55;
        this.renderCustomerDetails();

        // Table Heading
        this.renderInvoiceTable();

        // Document Footer
        this.renderDocumentFooter();

        // Save file
        this.doc.save(`statement-${this.customer.accountNumber}.pdf`);
    }
}